const getBudgetMin = (budgetString: string) => {
    if (budgetString === '+$50,000') return '50000'
    let newString = budgetString.replace(/\$/g, '').replace(/\,/g, '')
    let minPrice = newString.split('-')[0].trim()
    return minPrice
}

const getBudgetMax = (budgetString: string) => {
    if (budgetString === '+$50,000') return '100000'
    let newString = budgetString.replace(/\$/g, '').replace(/\,/g, '')
    let maxPrice = newString.split('-')[1].trim()
    return maxPrice
}
export const formatDateObj = (dateObj: Date) => {
    var date = new Date(dateObj)
    var dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split('T')[0]
    return dateString
}

export const getBudget = (budget: string) => [getBudgetMin(budget), getBudgetMax(budget)]
